import Table from '@/common/components/Table';
import { useCommonDataContext } from '@/common/hooks/commonDataContext';
import React from 'react';
import { HEADERS } from './constants/headers';
import { getRaws } from './helpers/getRaws';

const DepartmentTable = ({ departments, handleSetDepartmentEdit }) => {
	const {
		options: { usersOptions },
	} = useCommonDataContext();

	return (
		<Table
			className='styled-table'
			headers={HEADERS}
			raws={getRaws(departments, usersOptions, handleSetDepartmentEdit)}
		/>
	);
};

export default DepartmentTable;
